import { generateGuid } from '../../../../utils/typedHelper';

export interface DocumentSection {
    id: string;
    name: string;
    isLetterSection: boolean;
    isLoiSection: boolean;
    index: number;
    isAvailableForBuyers: boolean;
}

export const EngagementAgreementSectionName = 'Engagement Agreements';

export const GenerateDocumentSectionList = (): DocumentSection[] => [
    {
        id: generateGuid(),
        name: EngagementAgreementSectionName,
        isLetterSection: true,
        isLoiSection: false,
        index: 1,
        isAvailableForBuyers: false,
    },
    {
        id: generateGuid(),
        name: 'Stage 1 NDA (Identification)',
        isLetterSection: false,
        isLoiSection: false,
        index: 2,
        isAvailableForBuyers: false,
    },
    {
        id: generateGuid(),
        name: 'Stage 2 NDA (data / restrictive covenants)',
        isLetterSection: false,
        isLoiSection: false,
        index: 3,
        isAvailableForBuyers: false,
    },
    {
        id: generateGuid(),
        name: 'Informational Documents',
        isLetterSection: false,
        isLoiSection: false,
        index: 4,
        isAvailableForBuyers: false,
    },
    {
        id: generateGuid(),
        name: 'Seller Obligation Contracts',
        isLetterSection: false,
        isLoiSection: false,
        index: 5,
        isAvailableForBuyers: true,
    },
    {
        id: generateGuid(),
        name: 'LOIs',
        isLetterSection: false,
        isLoiSection: true,
        index: 6,
        isAvailableForBuyers: true,
    },
];
